// Modules
import cn from 'classnames';

// Types
import type { TCardMediaProps } from './Card.type';

// Styles
import styles from './styles.module.scss';

const CardMedia = (props: TCardMediaProps) => {
  const {
    children,
    className,
    ...restProps
  } = props;

  const cardMediaCN = cn(className, styles.legion_card_media);

  return (
    <div className={cardMediaCN} {...restProps}>
      {children}
    </div>
  );
};

CardMedia.displayName = 'CardMedia';
export default CardMedia;
